

















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    message: {
      type: String,
      required: false,
      default:
        'Du har ikke de nødvendige brugerettigheder til at se indholdet på denne side. Prøv venligst igen med en anden brugerkonto.'
    }
  }
});
